import daniel from "../resources/Daniel.jpeg"
import mision from "../resources/mision.jpg"
import vision from "../resources/vision.jpeg"
import valores from "../resources/valores.jpg"
import Porque from "../resources/Porque.jpeg"
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import "./Home.css"
import Page from '../components/Parallax'
import "../components/Listado.css"
import Listado from "../components/Listado"
import '../styles.css'
import CofeprisAdGallery from "../components/CofeprisAd"
import '../pages/marca.css'
import { Daniel } from "../resources"
import { useRef } from "react"
import CofeprisAdGalleryHome from "../components/CofeprisAdHome"

function Home() {
  const cofeprisRef = useRef();

  const razones = [
    "Soy especialista en ginecologia, obstetricia y colposcopia.",
    "Ofrezco una gran variedad de servicios médicos.",
    "Cuento con los equipos necesarios para brindar un buen servicio gineco-obstétrico.",
    "Precios accesibles.",
    "Confidencialidad y respeto en todo momento."
  ];

  return (
    <>
<div className="floating-buttons-container">
           <div className="floating-megafono"> <CofeprisAdGallery /></div>
          <div className="watermark-floating"></div>
          <FloatingWhatsApp
          className="floating-whatsapp"
            phoneNumber="5219511035059"
            avatar={Daniel}
            accountName="Dr. Daniel Sánchez Sarabia"
            chatMessage="¡Hola! ¿En qué puedo ayudarte?"
            placeholder="Escribe tu mensaje..."
            darkMode={false}
          />
      </div>

      <div className="container1">
        <div className="imagen">
          <img src={daniel} alt="Daniel" />
        </div>
        <div className="textobienvenida">
          <h1 className="texto1">
            <b>Dr. Daniel Sánchez Sarabia <br /> Gineco-obstetra colposcopista</b>
          </h1>
          <h2 className="texto1">
            “La salud es el regalo más grande, cuídate y protégete”
          </h2>
          <p className="texto2">
            Cédula profesional de especialista: <b>11611403</b>
          </p>
           <p 
            className="texto2 cofepris-link" 
            onClick={() => cofeprisRef.current?.openModal()}
          >
            Aviso de publicidad COFEPRIS
          </p>
        </div>
      {/* Modal oculto hasta que se abre */}
      <CofeprisAdGalleryHome ref={cofeprisRef} />
        </div>
      <Page
        offset={0}
        bgColor="#cf388c"
        image={mision}
        title="MISIÓN"
        text="Brindar atención ginecológica y obstétrica integral y personalizada 
              para las mujeres en todas las etapas de su vida, promoviendo su salud 
              reproductiva, bienestar emocional y autonomía, con respeto y profesionalismo."
      />

      <Page
        offset={1}
        bgColor="#78dbc5"
        image={vision}
        title="VISIÓN"
        text="Ser un ginecólogo reconocido en los Valles Centrales de Oaxaca por su 
              excelencia médica, enfoque preventivo y trato personalizado, contribuyendo 
              a la reducción del índice de enfermedades ginecológicas, así como a fomentar 
              la salud reproductiva responsable y el bienestar de las pacientes."
      />

      <Page
        offset={2}
        bgColor="#cf388c"
        image={valores}
        title="VALORES"
        text="Brindamos atención con EMPATÍA para escuchar y comprender al paciente; actuamos con RESPETO al valorar su autonomía y garantizar la confidencialidad; trabajamos con RESPONSABILIDAD dando seguimiento personalizado; y fomentamos la TRANSPARENCIA al comunicar claramente sobre tratamientos y costos."
      />


      <div className="listado-wrapper">
        <Listado items={razones} image={Porque} titulo="¿Por qué elegirme?" />
      </div>

      <div className="mapa-container">
        <h2>¿Dónde encontrarme?</h2>
        <div className="mapa-iframe">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3814.158276156908!2d-96.7178421!3d17.064909000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDAzJzUzLjciTiA5NsKwNDMnMDQuMiJX!5e0!3m2!1ses!2smx!4v1747025616004!5m2!1ses!2smx"
            width="600"
            height="450"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </>
  );
}

export default Home;
